import React from "react";
import {useFulfillmentType} from "@widgets/pos/order/hooks/UseFulfillmentType";
import useProductInfo from "../context/ProductInfoProvider";
import {selectionToTotalPrice} from "@/data/entities/cart/utils";
import {FormattedMessage} from "react-intl";


const DisplayPrice = () => {
    const fulfillmentType = useFulfillmentType();
    const {productSelection} = useProductInfo();
    const totalPrice: string = selectionToTotalPrice(productSelection, fulfillmentType);

    return (
        <FormattedMessage
            id={"add-with-price"}
            values={{price: totalPrice}}
        />
    );
};

export default DisplayPrice;